import { gql } from '@apollo/client';

export const fetchContactDetailsFromContactService = gql`
  query fetchContactDetailsFromContactService(
    $resourceAri: String
    $contactType: [ContactType]
    $transactionAccountId: String
  ) {
    contactsByResource(
      resourceAri: $resourceAri
      contactType: $contactType
      transactionAccountId: $transactionAccountId
    ) {
      accountId
      email
      name
      picture
      updatedAt
      isPrimary
    }
  }
`;
